// Kinde tenant configuration sourced from Vite env vars. Inlined at
// build time by CI per env; ``yarn dev`` falls back to the dev tenant
// defaults. Mirrors the shape of ``shared-components/auth/kindeEnvironment.ts``
// in the frontends repo, but kept inline here so the inrange-agents
// web app stays self-contained.

export interface KindeConfig {
  // Full origin of the user-facing Kinde auth domain, e.g.
  // "https://auth.inrange.io" - a CNAME to the underlying Kinde tenant
  // ("inrange.kinde.com" / "inrange-development.eu.kinde.com"). Google
  // OAuth allowlists the custom domain only, so the React SDK MUST use
  // this rather than the raw tenant URL or the redirect_uri_mismatch
  // bites. Matches the frontends repo's KINDE_AUTH_DOMAIN constant.
  readonly domain: string;
  readonly clientId: string;
  readonly audience: string;
  readonly orgCode: string;
}

// Local-dev fallback: the dev-tenant InRange-Agents application. The
// values match the ``qa-agents`` entry in
// ``infra/env_config.py:CI_ACCOUNTS`` and the dev-tenant org/audience
// the admin-app's KindeEnvironment.ts uses.
const LOCAL_DEFAULTS: KindeConfig = {
  domain: "https://auth.inrange.dev",
  clientId: "0f5a63eebb4b4439a94a078d8ec7f8a0",
  audience: "inrange-agents",
  orgCode: "org_930bea1210ea",
};

export const KINDE_CONFIG: KindeConfig = {
  domain: import.meta.env.VITE_KINDE_DOMAIN ?? LOCAL_DEFAULTS.domain,
  clientId: import.meta.env.VITE_KINDE_CLIENT_ID ?? LOCAL_DEFAULTS.clientId,
  audience: import.meta.env.VITE_KINDE_AUDIENCE ?? LOCAL_DEFAULTS.audience,
  orgCode: import.meta.env.VITE_KINDE_ORG_CODE ?? LOCAL_DEFAULTS.orgCode,
};
